import React from 'react'
import PropTypes from 'prop-types'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'

class ConfirmationModal extends React.Component {
  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
  }
  static defaultProps = {
    show: false,
  }

  constructor(props) {
    super(props)

    this.state = {
      wait: false,
    }
  }

  handleCancel = e => {
    const { onCancel } = this.props
    this.setState({ wait: false })
    onCancel()
  }

  handleConfirm = e => {
    const doConfirm = new Promise((resolve, reject) => {
      try {
        this.props.onConfirm()
        resolve()
      } catch (err) {
        reject(err)
      }
    })
    this.setState({ wait: true }, () => {
      doConfirm.then(this.handleCancel).catch(err => {
        console.error(err)
        this.setState({ wait: false })
      })
    })
  }

  render = () => {
    const { wait } = this.state
    const { show, title, children } = this.props
    return (
      <Modal
        backdrop="static"
        centered
        fade
        isOpen={show}
        toggle={this.handleCancel}
      >
        <ModalHeader toggle={this.handleCancel}>{title}</ModalHeader>
        <ModalBody>
          {children}
          <p className="font-weight-bold">Would you like to continue?</p>
        </ModalBody>
        <ModalFooter>
          <Button
            aria-label="Cancel"
            autoFocus
            className="btn-fixed-width"
            color="link"
            onClick={this.handleCancel}
          >
            Cancel
          </Button>
          <Button
            aria-label="Confirm"
            className="btn-fixed-width"
            color="primary"
            disabled={wait}
            onClick={this.handleConfirm}
          >
            {wait && <i className="fas fa-spinner fa-spin" />}
            {!wait && 'Confirm'}
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ConfirmationModal



// WEBPACK FOOTER //
// ./src/components/ConfirmationModal.js